const unsupported = async () => {
  throw new Error('Native filesystem access is unavailable in the browser');
};

const RNFS = {
  CachesDirectoryPath: '',
  DocumentDirectoryPath: '',
  copyFile: unsupported,
  exists: async () => false,
  mkdir: unsupported,
  moveFile: unsupported,
  readFile: unsupported,
  unlink: async () => undefined,
  writeFile: unsupported,
};

export default RNFS;
